var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesReporting/ReportTable.scss";
import { GenericDropdown, } from "@frameworks/shared-library/components/GenericDropdown";
import InputField from "@frameworks/web/components/generic/inputField";
import { Table } from "react-bootstrap";
import { entriesDropdownList } from "./ReportConstants";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import CustomPagination from "@frameworks/shared-library/components/CustomPagination";
import { addCommasWithoutDecimal } from "@domains/utils/numberMethods";
import Arrows from "@frameworks/web/components/generic/TableHeaderArrows";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
var ReportTable = function (props) {
    var _a = __read(useState(), 2), selectedEntry = _a[0], setSelectedEntry = _a[1];
    var _b = __read(useState(false), 2), sortingType = _b[0], setSortingType = _b[1];
    var _c = __read(useState(null), 2), clickedIndex = _c[0], setClickedIndex = _c[1];
    var _d = __read(useState(null), 2), tableBodyData = _d[0], setTableBodyData = _d[1];
    var _e = __read(useState(false), 2), isTableLinkView = _e[0], setIsTableLinkView = _e[1];
    var startIndex = (props === null || props === void 0 ? void 0 : props.totalitems)
        ? ((props === null || props === void 0 ? void 0 : props.currentPage) - 1) * (props === null || props === void 0 ? void 0 : props.pageSize) + 1
        : 0;
    var endIndex = (props === null || props === void 0 ? void 0 : props.totalitems)
        ? Math.min((props === null || props === void 0 ? void 0 : props.currentPage) * (props === null || props === void 0 ? void 0 : props.pageSize), props === null || props === void 0 ? void 0 : props.totalitems)
        : 0;
    var applySortingAccordingKey = function (key, dataType, sortType, data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setSortingType(sortType);
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        setTableBodyData(props === null || props === void 0 ? void 0 : props.tbodyData);
    }, [props === null || props === void 0 ? void 0 : props.tbodyData]);
    return (React.createElement("div", { className: "report-table-primaryContainer" },
        (props === null || props === void 0 ? void 0 : props.showHeader) &&
            ((props === null || props === void 0 ? void 0 : props.headerComp) ? (props === null || props === void 0 ? void 0 : props.headerComp) : (React.createElement("div", { className: "table-header" },
                (props === null || props === void 0 ? void 0 : props.showEntries) ? (React.createElement("div", { className: "entries-block" },
                    React.createElement("span", { className: "DMSanN_16_400" }, "Show"),
                    React.createElement("span", null,
                        React.createElement(GenericDropdown, { itemlist: entriesDropdownList, defaultVal: true, selectedValue: function (e) {
                                setSelectedEntry(e);
                            } })),
                    React.createElement("span", { className: "DMSanN_16_400" }, "Entries"))) : (props === null || props === void 0 ? void 0 : props.showTableExportBtn) ? (React.createElement("div", { className: "button-block" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Export" }))) : (React.createElement("div", null)),
                (props === null || props === void 0 ? void 0 : props.isShowSearch) &&
                    tableBodyData &&
                    (tableBodyData === null || tableBodyData === void 0 ? void 0 : tableBodyData.length) > 0 && (React.createElement("div", { className: "search-block" },
                    React.createElement("span", { className: "DMSanN_16_400" }, "Search"),
                    React.createElement(InputField, { placeholderClassName: "", defaultValue: props === null || props === void 0 ? void 0 : props.searchText, onBlur: function () { }, onChangeEvent: function (e) {
                            (props === null || props === void 0 ? void 0 : props.setSearchText) &&
                                (props === null || props === void 0 ? void 0 : props.setSearchText(e.target.value));
                        } })))))),
        React.createElement("div", { className: "table-block" },
            React.createElement(Table, { responsive: true, className: "sales-report-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null, props.columnsList &&
                        props.columnsList.map(function (column, idx) {
                            var _a;
                            return (React.createElement("th", { key: idx, className: "".concat(column.columnClass ? column.columnClass : ""), onClick: function () {
                                    var _a, _b;
                                    ((_a = column === null || column === void 0 ? void 0 : column.property) === null || _a === void 0 ? void 0 : _a.isSort) &&
                                        tableBodyData &&
                                        (tableBodyData === null || tableBodyData === void 0 ? void 0 : tableBodyData.length) > 0 &&
                                        (props === null || props === void 0 ? void 0 : props.onSort({
                                            key: column.key,
                                        }));
                                    setClickedIndex(idx);
                                    props === null || props === void 0 ? void 0 : props.setClickedIndex(idx);
                                    applySortingAccordingKey(column.key, (_b = column === null || column === void 0 ? void 0 : column.property) === null || _b === void 0 ? void 0 : _b.coloumntype, !sortingType);
                                } },
                                React.createElement("span", null, ((_a = column === null || column === void 0 ? void 0 : column.property) === null || _a === void 0 ? void 0 : _a.isSort) ? (React.createElement(Arrows, { className: "me-1", sortType: (props === null || props === void 0 ? void 0 : props.sortingType)
                                        ? props === null || props === void 0 ? void 0 : props.sortingType
                                        : sortingType, key: column === null || column === void 0 ? void 0 : column.key, title: column.name, isClicked: idx ===
                                        ((props === null || props === void 0 ? void 0 : props.clickedIndex) >= 0
                                            ? props === null || props === void 0 ? void 0 : props.clickedIndex
                                            : clickedIndex) })) : (column.name))));
                        }))),
                tableBodyData && (tableBodyData === null || tableBodyData === void 0 ? void 0 : tableBodyData.length) > 0 ? (React.createElement("tbody", { className: "".concat("") }, tableBodyData &&
                    (tableBodyData === null || tableBodyData === void 0 ? void 0 : tableBodyData.length) > 0 &&
                    tableBodyData.map(function (row, trId) {
                        return (React.createElement("tr", { key: trId }, props.columnsList &&
                            props.columnsList.map(function (column, id) {
                                var _a, _b, _c;
                                return (React.createElement("td", { key: id, className: "".concat(((_a = column === null || column === void 0 ? void 0 : column.property) === null || _a === void 0 ? void 0 : _a.islink)
                                        ? "text-decoration-underline hand_cursor"
                                        : ""), onClick: function () {
                                        var _a;
                                        if ((_a = column === null || column === void 0 ? void 0 : column.property) === null || _a === void 0 ? void 0 : _a.islink) {
                                            props === null || props === void 0 ? void 0 : props.getRowData(row, column);
                                            setIsTableLinkView(true);
                                        }
                                        else {
                                            setIsTableLinkView(false);
                                        }
                                    } }, ((_b = column === null || column === void 0 ? void 0 : column.property) === null || _b === void 0 ? void 0 : _b.isView) ? (React.createElement(EdButton, { onClick: function () {
                                        props === null || props === void 0 ? void 0 : props.getRowData(row, column);
                                    }, btnTyp: "midnight-blue-border", value: "View", className: "column-button", type: "button" })) : row["".concat(column.key)] ? (((_c = column === null || column === void 0 ? void 0 : column.property) === null || _c === void 0 ? void 0 : _c.coloumntype) === "int" ? (Math.floor(Number(row["".concat(column.key)]))) : (row["".concat(column.key)])) : ("-")));
                            })));
                    }))) : (React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 10 },
                            React.createElement("div", null,
                                React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })))))))),
        tableBodyData && (tableBodyData === null || tableBodyData === void 0 ? void 0 : tableBodyData.length) > 0 && (React.createElement("div", { className: "pagination-block " },
            React.createElement("span", { className: "DMSanN_16_400" },
                "Showing ",
                addCommasWithoutDecimal(startIndex),
                " to",
                " ",
                addCommasWithoutDecimal(endIndex),
                " of",
                " ",
                addCommasWithoutDecimal(props === null || props === void 0 ? void 0 : props.totalitems),
                " entries"),
            (props === null || props === void 0 ? void 0 : props.showEntriesCount) && (React.createElement(CustomPagination
            // isReportsPagination
            , { 
                // isReportsPagination
                totalPages: props === null || props === void 0 ? void 0 : props.totalPages, getData: function (page) {
                    props === null || props === void 0 ? void 0 : props.getCurrentPage(page, isTableLinkView);
                }, currentPage: props === null || props === void 0 ? void 0 : props.currentPage }))))));
};
export default ReportTable;
